<script lang="ts">
    import type { SVGAttributes } from "svelte/elements";

    interface $$Props extends SVGAttributes<SVGSVGElement>{
        r?: number
    }

    export let r: $$Props["r"] = 60
</script>

<svg {...$$restProps} viewBox="0 0 120 120">
    <circle
        stroke="none"
        fill="currentColor"
        {r}
        cx=50%
        cy=50%
    />
</svg>